{
  "common": {
    "saveChanges": "SAVE CHANGES",
    "savingChanges": "SAVING CHANGES...",
    "cancel": "CANCEL",
    "title": "Sign In",
    "signIn": "SIGN IN",
    "save": "Save",
    "troubleSigningIn": "Trouble Signing In?",
    "resetPassword": "Reset Password",
    "email": "Email",
    "password": "Password",
    "findFieldByName": "Find field by name...",
    "find": "Find",
    "by": "By",
    "choose": "Choose...",
    "selectPeriod": "Select Period...",
    "reasonForRetiring": "Reason for Retiring",
    "selectReason": "Select Reason...",
    "selectAll": "Select All",
    "clearAll": "Clear All",
    "selectedCount": "{{count}} selected",
    "otherReasonDescription": "Please Specify the Reason",
    "address": "Address",
    "addressContinued": "Address (continued)",
    "city": "City",
    "stateProvince": "State / Province",
    "postalCode": "Postal Code",
    "requiredField": "* Required field",
    "apply": "APPLY",
    "applying": "APPLYING...",
    "clear": "CLEAR",
    "filters": "Filters",
    "loading": "Loading...",
    "yes": "Yes",
    "no": "No",
    "close": "Close",
    "after": "after",
    "viewDashboard": "View Dashboard",
    "enterName": "Enter Name",
    "alreadyHaveAccount": "Already have an account?",
    "enterEmailAssociatedWithAccount": "Enter the email address associated with your account and we'll send you a link to reset your password.",
    "restartPageTour": "Restart page tour",
    "status": "Status",
    "name": "Name",
    "active": "Active",
    "retired": "Retired",
    "all": "All",
    "comments": "Comments",
    "finalized": "Finalized",
    "firstReportingPeriod": "First Reporting Period",
    "lastReportingPeriod": "Last Reporting Period",
    "theLastReportingPeriod": "the last reporting period",
    "retire": "Retire",
    "retireButton": "RETIRE",
    "retiringButton": "RETIRING...",
    "program": "Program",
    "reportingPeriod": "Reporting Period",
    "totalKwh": "Total kWh",
    "clientName": "Client Name",
    "remittanceMethod": "Remittance Method",
    "generalInfo": "General Information",
    "facility": "Facility",
    "facilities": "Facilities",
    "unsavedFilters": "Filters were not applied"
  },
  "language": {
    "en": "English",
    "fc": "French"
  }
}
